import React, { Fragment, useEffect, useContext, useState } from "react";
import { Link, Redirect } from "react-router-dom";
import { observer, useObserver } from "mobx-react-lite";

/* packages */
import { GlobalContext } from "../../lib-atomic-context";
import { LocalStorage } from "../../lib-atomic-functions";

import {
  ModuleTitle,
  ModuleText,
  ModuleTextSmall,
  ModuleSubTitle,
  ModuleFormWrapper,
  ModuleFormItemWrapper,
  ModuleFormItemShortWrapper,
  ModuleFormItemLongWrapper,
  ModulePaperWrapper,
  ModuleTextProductTotal,
} from "../../lib-atomic-design-section";
/* packages */

const index = (props) => {
  const { product, fees } = useContext(GlobalContext);
  const [productTotal, setProductTotal] = useState("$00.00");

  useEffect(() => {
    handleTotal();
  }, [product]);

  const handleTotal = () => {
    const productLS = LocalStorage.getLS().products;
    const feesLS = LocalStorage.getLS().fees;
    // console.log("handle Total ", productLS, feesLS);
    let total = 0;
    let fee = 0;
    productLS &&
      productLS.map((item, index) => {
        total = total + item.value * item.quantity;
      });
    if (feesLS) fee = parseFloat(feesLS.courier) + parseFloat(feesLS.pAndH);

    total = total + fee;
    total = "$" + parseFloat(total).toFixed(2);
    setProductTotal(total);
  };

  return (
    <ModuleFormItemLongWrapper>
      <ModulePaperWrapper>
        <ModuleFormWrapper>
          <ModuleFormItemLongWrapper>
            <ModuleSubTitle>
              <b>Total</b>
            </ModuleSubTitle>
            <ModuleText>
              <b>{productTotal}</b>
            </ModuleText>
          </ModuleFormItemLongWrapper>
        </ModuleFormWrapper>
      </ModulePaperWrapper>
    </ModuleFormItemLongWrapper>
  );
};

export default index;
